import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from '../Button';
import styles from './style';
import './comstyle.css';

class Cell extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.hide = this.hide.bind(this);
  }
  hide(index) {
    this.props.callbackRM(index);
  }
  render() {
    const self = this;
    const options = self.props.options;
    const leftCon = Object.assign({}, styles.leftCon);
    const rightX = Object.assign({}, styles.rightX);
    const buttons = options.buttons.map((im) => {
      let rbutton = '';
      if (im.model === 'sure') {
        rbutton = (<Button
          text={im.tirtle}
          type={im.type}
          onClick={() => { self.hide(options.id); im.callbk(); }}
          style={styles.marginRight}
          key={im.tirtle}
        />);
      } else {
        rbutton = (<Button
          text={im.tirtle}
          type={im.type}
          onClick={() => { self.hide(options.id); im.callbk(); }}
          style={styles.marginRight}
          key={im.tirtle}
        />);
      }
      return rbutton;
    });
    return (
      <div style={styles.box} >
        <div style={styles.continer}>
          <div style={styles.tirtle} >
            <div style={leftCon}>{options.tirtle}</div>
            <span style={rightX} onClick={() => { self.hide(options.id); }}>x</span>
          </div>
          <div style={styles.content}>{options.content}</div>
          <div style={styles.foot}>
            {buttons}
          </div>
        </div>
      </div>
    );
  }
}

Cell.propTypes = {
  callbackRM: PropTypes.func
  // style: PropTypes.shape({})
};

Cell.defaultProps = {
  options: [],
  callbackRM: () => {}
};

export default Cell;



// WEBPACK FOOTER //
// ./src/Components/Modal/cell.js